module.exports = __webpack_public_path__ + "img/expert_avatar_6.9de37646.png";